export default __webpack_public_path__ + "63a92e35faa4ef6967fd36fe8cc337a0.png";